import { useId } from 'react';

export const GoogleFormsIcon = ({ className }: { className?: string }) => {
  const uid = useId().replace(/:/g, '');
  const maskId = `google-forms-mask-${uid}`;
  const blurId = `google-forms-blur-${uid}`;

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 800 789.4737"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="536.8421"
        height="263.1579"
        x="263.1579"
        y="526.3158"
        fill="#969dff"
        rx="131.5789"
      />
      <rect
        width="263.1579"
        height="263.1579"
        x="0"
        y="526.3158"
        fill="#b8c0ff"
        rx="131.5789"
      />
      <rect
        width="263.1579"
        height="263.1579"
        x="0"
        y="263.1579"
        fill="#5746e3"
        rx="131.5789"
      />
      <rect
        width="536.8421"
        height="263.1579"
        x="263.1579"
        y="263.1579"
        fill="#5746e3"
        rx="131.5789"
      />
      <mask
        id={maskId}
        width="102"
        height="50"
        x="70"
        y="21"
        maskUnits="userSpaceOnUse"
      >
        <rect width="102" height="50" x="70" y="21" fill="#fff" rx="25" />
      </mask>
      <g
        mask={`url(#${maskId})`}
        transform="matrix(5.2631579,0,0,5.2631579,-105.26316,-110.52632)"
      >
        <rect width="102" height="50" x="70" y="21" fill="#7372fe" rx="25" />
        <g filter={`url(#${blurId})`}>
          <circle cx="56" cy="46" r="36" fill="#64afff" />
        </g>
      </g>
      <rect
        width="263.1579"
        height="263.1579"
        x="0"
        y="0"
        fill="#7372fe"
        rx="131.5789"
      />
      <path
        stroke="#ffffff"
        strokeLinecap="round"
        strokeWidth="63.6"
        d="M394.7368 131.579h273.6843"
      />
      <circle cx="131.5789" cy="131.5789" r="63.1579" fill="#ffffff" />
      <defs>
        <filter
          id={blurId}
          width="111.47"
          height="111.47"
          x=".27"
          y="-9.74"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feGaussianBlur stdDeviation="9.87" />
        </filter>
      </defs>
    </svg>
  );
};
